import React from "react";
import "../App.css";
import "twin.macro";
import ServicesSection from "../components/Sections/ServicesSection";
import TeamSection from "../components/Sections/TeamSection";
import Contact from "../components/Contact/Contact";
import { Element } from "react-scroll";
import HomeSection from "../components/Sections/HomeSection";
import WhyChooseUsSection from "../components/Sections/WhyChooseUsSection/WhyChooseUsSection";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
// import OurClientSection from "../components/Sections/OurClientSection";
// import TestimonialSection from "../components/Sections/TestimonialSection";

function IndexPage() {
  return (
    <main tw="bg-gray-700">
      <Seo title="Home" description="We provide the user-friendly interface of websites and apps for android platforms coupled with a minimalistic design. We help you to grow your business. We design visually compelling designs with a great concept behind them. Content is the king in the market our team understands the importance of engaging content to keep the audience on board with the website/ product." />
      <Layout>
        <Element name="home" className="element">
          <HomeSection />
        </Element>

        <Element name="services" className="element">
          <ServicesSection />
        </Element>

        <Element name="team" className="element">
          <WhyChooseUsSection />
        </Element>
        <Element name="team" className="element">
          <TeamSection />
        </Element>

        {/* <OurClientSection />
        <TestimonialSection /> */}

        <Element name="contact" className="element">
          <Contact />
        </Element>
      </Layout>
    </main>
  );
}

export default IndexPage;
